export default "__VITE_ASSET__Jzi$_ZlC__"